import { Box } from '@fe-toolkit/web-components/ssr'

export function ProfileSection({ children }: { children?: React.ReactNode }) {
  return (
    <Box as="section" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {children}
    </Box>
  )
}
